export default __webpack_public_path__ + "static/media/person_2.3c1731d6.jpeg";